import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss']
})
export class SectionComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
